import { down } from 'styled-breakpoints';
import styled from 'styled-components';

// Pulsante con gli stili di un link
export const FixedHeightBlock = styled.div`
  min-height: 120px;
  ${down('xl')} {
    min-height: 100px;
  }
  ${down('md')} {
    min-height: unset;
  }
`;
